import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-unplanned-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/unplanned"
    message_if_none = 'No jobs that are unplanned.'
  />,
document.getElementById('react-component-g4-logistics-portal-unplanned-jobs'));
}

if (document.getElementById('react-component-g4-logistics-portal-unplanned2-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/unplanned2"
    infiniteScroll={true}
    message_if_none = 'No jobs that are unplanned.'
  />,
document.getElementById('react-component-g4-logistics-portal-unplanned2-jobs'));
}
